import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalDetails } from '../../types/user';

const initialState: PersonalDetails = {
  firstName: '',
  lastName: '',
  preferredName: '',
  email: '',
  dob: '',
  races: [],
  sexualOrientation: '',
  pronounsList: [],
  gender: '',
  school: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  // preferredLanguage: '',
};

export const personalDetailsSlice = createSlice({
  name: 'personalDetails',
  initialState,
  reducers: {
    setPersonalDetails: (state, action: PayloadAction<PersonalDetails>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearPersonalDetails: () => initialState,
  },
});

export const { setPersonalDetails, clearPersonalDetails } = personalDetailsSlice.actions;
export default personalDetailsSlice.reducer;
